export default "https://cdn-static.gokick.com/assets/b4d66d8cd7eb0aaa0b454a3d41ce872cff261527/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";